/* eslint-disable react/prop-types */
/* eslint-disable no-alert */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-return-await */
/* eslint-disable react/no-unknown-property */
import { Button, FormControl, FormHelperText, MenuItem, Select, Stack, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useCookies } from 'react-cookie'
import ChevronDownIcon from '../assets/icons/ChevronDownIcon'
import DownloadIcon from '../assets/icons/DownloadIcon'
import axios from '../axios'
import { awsConfig } from '../config'
import { toastMessageStyle } from '../style/toastMessage'

const Types = [
  { key: 'simple', value: 'Simple' },
  { key: 'full', value: 'Full' },
]

const MAX_YEAR = dayjs()

const BillingReportTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32px',
  color: '#233A4F',
  width: '158px',
  height: '32px',
}))

const StyledDatePicker = styled(DatePicker)(() => ({
  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    width: '300px',
    maxHeight: '48px',
    paddingRight: '0',
  },
  '& .MuiInputBase-input.MuiOutlinedInput-input': {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#868891',
    height: '24px',
    width: '238px',
    margin: '12px 0px 12px 16px',
    padding: '0',
  },
  '& .MuiInputBase-input.MuiOutlinedInput-input::placeholder': {
    opacity: '1',
  },
  '& .MuiInputAdornment-root': {
    marginLeft: '10px',
  },
  '& .MuiButtonBase-root.MuiIconButton-root': {
    padding: '0',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E0E2E7',
    borderRadius: '8px',
  },
  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: '#F32D2D',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: '#F32D2D',
    margin: '8px 0px',
    width: '301px',
    height: ' 24px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
  },
}))

const StyledSelect = styled(Select)(() => ({
  width: '300px',
  height: '48px',
  '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
    padding: '12px 46px 12px 16px',
    width: '238px',
    height: '24px',
  },
  '& .MuiStack-root': {
    height: '20px',
    position: 'absolute',
    right: '16px',
    pointerEvents: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E0E2E7',
    borderRadius: '8px',
  },
  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: '#F32D2D',
  },
}))

const StyledHelperText = styled(FormHelperText)(() => ({
  '&.MuiFormHelperText-root.Mui-error': {
    color: '#F32D2D',
  },
  margin: '8px 0px',
  width: '301px',
  height: ' 24px',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '24px',
}))

const ReportTypePlaceholder = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  color: '#868891',
}))

const DownloadButton = styled(Button)(() => ({
  padding: '12px 20px',
  marginLeft: '48px',
  marginTop: '28px',
  width: '151px',
  height: '48px',
  color: '#FFFFFF',
  background: '#4872DE',
  borderRadius: '8px',
  gap: '12px',
  textTransform: 'none',
  '& .MuiButton-startIcon': {
    margin: '0',
  },
}))

const DownloadText = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '24px',
  width: '79px',
}))

function DropdownLabel(props) {
  const { label, isValid, hasValue } = props
  let color = '#232325'

  if (isValid !== undefined) {
    if (!hasValue) color = '#F32D2D'
  }

  return (
    <Typography
      sx={{
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        color,
        mb: '4px',
      }}>
      {label}
    </Typography>
  )
}

function BillingReport() {
  const [cookies] = useCookies()
  const token = cookies?.token
  const { enqueueSnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isValid, setIsValid] = useState()
  const [year, setYear] = useState()
  const [month, setMonth] = useState()
  const [reportType, setReportType] = useState(null)

  const handleDownloadButtonClick = async () => {
    const isInValid = !(year && month && reportType)
    if (isInValid) {
      setIsValid(false)
      return
    }

    try {
      setIsLoading(true)
      const url = `${awsConfig.apiEndpoint}/?mode=queryPreGenerateBillingReport&year=${year}&month=${month + 1}&type=${reportType}&openIdToken=${token}`
      const res = await axios.get(url)
      window.location.href = res.data
    } catch (e) {
      if (e.response.status === 404) {
        enqueueSnackbar('File Not Found', {
          variant: 'error',
          sx: toastMessageStyle,
        })
      } else {
        console.log('error', e.response.data)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const renderSelectedValue = (value) => {
    if (value === '') {
      return <ReportTypePlaceholder component="span">Select</ReportTypePlaceholder>
    }

    return Types.find((t) => t.key === value).value
  }

  return (
    <Stack mt="32px" ml="24px" flex="1">
      <BillingReportTitle variant="h4">Billing Report</BillingReportTitle>
      <Stack direction="row" mt="36px">
        <Stack direction="row" spacing={3}>
          <Stack>
            <DropdownLabel label="Year *" isValid={isValid} hasValue={!!year} />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StyledDatePicker
                views={['year']}
                onChange={(value) => {
                  setYear(value?.year())
                }}
                slots={{
                  openPickerIcon: ChevronDownIcon,
                }}
                onError={(error, value) => {
                  setYear(error ? undefined : value.year())
                }}
                slotProps={{
                  textField: {
                    placeholder: 'Select',
                    error: isValid === false && !year,
                    helperText: isValid === false && !year && 'Please Select',
                  },
                }}
                maxDate={MAX_YEAR}
              />
            </LocalizationProvider>
          </Stack>
          <Stack>
            <DropdownLabel label="Month *" isValid={isValid} hasValue={!!month} />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StyledDatePicker
                views={['month']}
                format="M"
                onChange={(value) => {
                  setMonth(value?.month())
                }}
                slots={{
                  openPickerIcon: ChevronDownIcon,
                }}
                slotProps={{
                  textField: {
                    placeholder: 'Select',
                    error: isValid === false && !month,
                    helperText: isValid === false && !month && 'Please Select',
                  },
                  popper: {
                    sx: {
                      '& .MuiPickersCalendarHeader-root': {
                        display: 'none',
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Stack>
          <Stack>
            <DropdownLabel label="Type *" isValid={isValid} hasValue={!!reportType} />
            <FormControl>
              <StyledSelect
                displayEmpty
                defaultValue=""
                onChange={(event) => {
                  setReportType(event.target.value)
                }}
                renderValue={(value) => renderSelectedValue(value)}
                error={isValid === false && !reportType}
                IconComponent={ChevronDownIcon}>
                {Types.map((t) => (
                  <MenuItem key={t.key} value={t.key}>
                    {t.value}
                  </MenuItem>
                ))}
              </StyledSelect>
              {isValid && reportType === null && <StyledHelperText error>Please Select</StyledHelperText>}
            </FormControl>
          </Stack>
        </Stack>
        <DownloadButton variant="contained" onClick={handleDownloadButtonClick} disabled={isLoading} startIcon={<DownloadIcon />}>
          <DownloadText>Download</DownloadText>
        </DownloadButton>
      </Stack>
      {isLoading && (
        <Stack justifyContent="center" alignItems="center" flex="1">
          <CircularProgress />
        </Stack>
      )}
    </Stack>
  )
}

export default BillingReport
